import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import userService from '../../services/UserService';
import NavUser from '../../components/user/NavUser';
import "./User.css";
import "../../static/css/alert.css";

export default function SecurityUser() {
    const { register, handleSubmit, setValue, formState: { errors }, watch, setError, clearErrors } = useForm();
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setErrorForm] = useState('');
    const [result, setResult] = useState('');
    // Per controllare se le password corrispondono
    const newpassword = watch('newpassword');
    const confirmpassword = watch('confirmpassword');

    const onSubmitSecurityUser = async (data) => {
        userService.changePassword(data)
        .then((res) => {
            if (res.data.statusCodeValue === 200) {
                setResult(res.data.body);
                setErrorForm('');
            } else if (res.data.statusCodeValue === 401) {
                setErrorForm(res.data.body);
                setResult('');
            }
        }).catch((error) => {
            if (error.status === 401)  {
                setErrorForm('Credenziali non valide');
                setResult('');
            } else {
                setErrorForm("Errore durante l'aggiornamneto, riprovare");
                setResult('');
                console.log(error);
            }
        });
    };
    // Usa useEffect per monitorare il cambiamento delle password
    useEffect(() => {
        // Recupera il dati dell'utente
        setValue('id_user', localStorage.getItem("id_user"));
        if (newpassword && confirmpassword) {
            if (newpassword !== confirmpassword) {
                setError('confirmpassword', { type: 'manual', message: 'Le password non corrispondono' });
            } else {
                clearErrors('confirmpassword');
            }
        }
    }, [newpassword, confirmpassword, setError, clearErrors]);

  	return (
        <div className="row">
            <div className="col-md-12">
                {/* Nav User */}
                <NavUser />
                {/* Nav User */}
                <div className="card mb-6">
                    <h5 className="card-header">Cambio Password</h5>
                    <div className="card-body pt-1">
                        {error && <div className="mb-6 text-center alert alert-outline-danger">{error}</div>}
                        {result && <div className="mb-6 text-center alert alert-outline-success">{result}</div>}
                        <form onSubmit={handleSubmit(onSubmitSecurityUser)}>
                            <input type="hidden" {...register('id_user')}/>
                            <div className="row">
                                <div className="mb-6 col-md-6">
                                    <label htmlFor="password" className="form-label">Password Corrente</label>
                                    <div className="input-group input-group-merge has-validation">
                                        <input type={`${showPassword ? "text" : "password"}`} autoComplete="password" className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                            placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" aria-describedby="password"
                                            {...register('password', { required: 'Inserisci la password' })}
                                        />
                                        <span className="input-group-text cursor-pointer">
                                            <i onClick={() => setShowPassword(!showPassword)}  className={`bx ${showPassword ? "bx-show" : "bx-hide"}`} ></i>
                                        </span>
                                        {errors.password && <div className="invalid-input">{errors.password.message}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-6 col-md-6">
                                    <label htmlFor="newpassword" className="form-label">Nuova Password</label>
                                    <div className="input-group input-group-merge has-validation">
                                        <input type={`${showNewPassword ? "text" : "password"}`} autoComplete="newPassword" className={`form-control ${errors.newpassword ? "is-invalid" : ""}`}
                                            placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                                            {...register('newpassword', {
                                                required: 'Inserisci la nuova password'
                                            })}
                                        />
                                        <span className="input-group-text cursor-pointer">
                                            <i onClick={() => setNewPassword(!showNewPassword)}  className={`bx ${showNewPassword ? "bx-show" : "bx-hide"}`} ></i>
                                        </span>
                                        {errors.newpassword && <div className="invalid-input">{errors.newpassword.message}</div>}
                                    </div>
                                </div>
                                <div className="mb-6 col-md-6">
                                    <label htmlFor="confirmpassword" className="form-label">Conferma Password</label>
                                    <div className="input-group input-group-merge has-validation">
                                        <input type={`${showConfirmPassword ? "text" : "password"}`} autoComplete="confirmPassword" className={`form-control ${errors.confirmpassword ? "is-invalid" : ""}`}
                                            placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                                            {...register('confirmpassword', {
                                                required: 'Inserisci la password da confermare',
                                                validate: value =>
                                                                value === newpassword || 'Le password non corrispondono',
                                            })}
                                        />
                                        <span className="input-group-text cursor-pointer">
                                            <i onClick={() => setShowConfirmPassword(!showConfirmPassword)} className={`bx ${showConfirmPassword ? "bx-show" : "bx-hide"}`} ></i>
                                        </span>
                                        {errors.confirmpassword && <div className="invalid-input">{errors.confirmpassword.message}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-6">
                              <button type="submit" className="btn btn-primary me-3">Save changes</button>
                              <button type="reset" className="btn btn-label-secondary">Reset</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
	);
}